export default "__VITE_ASSET__Ca8JoTV9__"